import { ChevronDown } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import heroAsset from "@/assets/hero-villa-new.png.asset.json";
import logoAsset from "@/assets/sohar-logo-hero-cream.png";
const heroImage = heroAsset.url;

const HeroSection = () => {
  const { t, lang } = useI18n();

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden bg-navy-light">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Sohar Real Estate"
          className="w-full h-full object-cover object-[75%_center] md:object-[center_30%]"
          style={{ opacity: 0.9 }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-navy/75 via-navy/30 to-navy/5" />
        <div className="absolute inset-x-0 top-0 h-44 bg-gradient-to-b from-navy/60 via-navy/25 to-transparent" />
      </div>


      <div className="relative z-10 container mx-auto px-4 md:px-6 text-center flex flex-col items-center justify-center pt-12 md:pt-0">
        <div className="animate-hero-fade-in mb-10 md:mb-12" style={{ animationDelay: '0.3s' }}>
          <img
            src={logoAsset}
            alt="Sohar Real Estate"
            className="h-28 sm:h-36 md:h-44 lg:h-52 w-auto mx-auto drop-shadow-2xl"
          />
        </div>

        <p
          className="animate-hero-fade-in text-slate-300 text-base md:text-xl max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed"
          style={{ animationDelay: '0.7s', textShadow: '0 1px 12px rgba(15,23,42,0.55)' }}
        >
          {t("hero.subtitle")}
        </p>

        <div
          className="animate-hero-fade-in flex flex-col sm:flex-row gap-4 justify-center"
          style={{ animationDelay: '0.9s' }}
        >
          <a href="#projects" className="bg-white text-navy font-bold px-8 md:px-10 py-3.5 md:py-4 rounded-xl text-base md:text-lg hover:opacity-90 transition-all hover:scale-105">
            {t("hero.cta1")}
          </a>
          <a href="#contact" className="border-2 border-white/40 text-white font-bold px-8 md:px-10 py-3.5 md:py-4 rounded-xl text-base md:text-lg hover:border-white hover:bg-white/10 transition-all">
            {t("hero.cta2")}
          </a>
        </div>
      </div>

      <div className="absolute bottom-10 left-0 right-0 flex justify-center z-10">
        <div className="animate-bounce-slow">
          <ChevronDown className="text-cream/50" size={32} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
